/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `field_capabilities` message.
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class FieldCapabilitiesMesg : Mesg {
    public constructor() : super("FieldCapabilities", Profile.MesgNum.FIELD_CAPABILITIES)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** message_index. */
    public var messageIndex: UShort?
        get() = getFieldValue(MESSAGE_INDEX_FIELD_NUM) as? UShort
        set(value) = setFieldValue(MESSAGE_INDEX_FIELD_NUM, value)

    /** file. */
    public var file: File?
        get() = (getFieldValue(FILE_FIELD_NUM) as? UByte)?.let { File.fromValue(it) }
        set(value) = setFieldValue(FILE_FIELD_NUM, value?.value)

    /** mesg_num. */
    public var mesgNum: MesgNum?
        get() = (getFieldValue(MESG_NUM_FIELD_NUM) as? UShort)?.let { MesgNum.fromValue(it) }
        set(value) = setFieldValue(MESG_NUM_FIELD_NUM, value?.value)

    /** field_num. */
    public var fieldNum: UByte?
        get() = getFieldValue(FIELD_NUM_FIELD_NUM) as? UByte
        set(value) = setFieldValue(FIELD_NUM_FIELD_NUM, value)

    /** count. */
    public var count: UShort?
        get() = getFieldValue(COUNT_FIELD_NUM) as? UShort
        set(value) = setFieldValue(COUNT_FIELD_NUM, value)

    public companion object {
        public const val MESSAGE_INDEX_FIELD_NUM: UByte = 254u
        public const val FILE_FIELD_NUM: UByte = 0u
        public const val MESG_NUM_FIELD_NUM: UByte = 1u
        public const val FIELD_NUM_FIELD_NUM: UByte = 2u
        public const val COUNT_FIELD_NUM: UByte = 3u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[254] = Field("MessageIndex", 254u, BaseType.UINT16, 1.0, 0.0, "", false)
            fields[0] = Field("File", 0u, BaseType.ENUM, 1.0, 0.0, "", false)
            fields[1] = Field("MesgNum", 1u, BaseType.UINT16, 1.0, 0.0, "", false)
            fields[2] = Field("FieldNum", 2u, BaseType.UINT8, 1.0, 0.0, "", false)
            fields[3] = Field("Count", 3u, BaseType.UINT16, 1.0, 0.0, "", false)
            return fields
        }
    }
}
